<input
  [disabled]="disabled"
  [ngModel]="ngModel"
  [readonly]="readonly"
  (ngModelChange)="ngModelChange.emit($event)"
  [placeholder]="placeholder"
  [class]="fontClass"
  type="text"
/>
